import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { AppService } from 'app/app.service';
import { fadeInSlideAnimation } from 'animations';
import { DomainStorageProvider } from 'providers/domain-storage/domain-storage';
import { LocalstorageProvider } from 'providers/localstorage/localstorage';
import { GetServiceUrl } from 'psapp-config';

@Component({
	selector: 'app-campaigns',
	templateUrl: './campaigns.component.html',
	styleUrls: ['./campaigns.component.scss'],

	animations: [fadeInSlideAnimation],
	host: { '[@fadeInSlideAnimation]': '' }
})
export class CampaignsComponent implements OnInit, OnDestroy {

	compaigns: any[];
    imageService = GetServiceUrl("ImageCampaign");
    isLoading:boolean = false;

	constructor(
		private router: Router,
		private appService: AppService,
		private domainStorageProvider: DomainStorageProvider,
		public storage: LocalstorageProvider
	) {
		this.showHideMenu(false);
	}

	ngOnInit() {
        this.fetchData();
    }
    
    async fetchData(){
        this.isLoading = true;
        let selectedGroup = this.domainStorageProvider.rootStore.selectedGroupId.value;
        //refresh groups
        await this.domainStorageProvider.getConfigData(!selectedGroup);
        this.compaigns = this.domainStorageProvider.rootStore.userGroups;
        this.isLoading = false;
    }

	ngOnDestroy() {
		this.showHideMenu(true);
	}

	showHideMenu(show) {
		this.appService.onMainMenuEvent.emit(show);
	}

	onSelectCampaign(campaign: any) {
		//set new selected campaign id
		this.domainStorageProvider.rootStore.selectedGroupId.next(campaign.id);

		//persist selection
		this.storage.write("selectedGroup", JSON.stringify({ group: this.domainStorageProvider.rootStore.getSelectedGroup() }));

		this.router.navigate(["/"]);
	}

	back() {
		this.router.navigate(["/"]);
	}
}
